import React, { useEffect, useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../assets/DataView/DataViewDemo.css";
import "../../assets/DataView/index.css";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import jsPDF from "jspdf";
import logoBig from "../../assets/logo1.png";
import { FilterMatchMode } from 'primereact/api';
import { errorMessage, successMessage } from "../../utils/alertMessage";
import { formatDate, formatDateWithTime } from "../../constants/FormateDate";
import { Dialog } from "primereact/dialog";
import { getLead, getLeadSource, getLeadStatusApi, getLeadType, getMasterLeadStatus, getUserLead, userLeadAssign } from "../../services/leads";
import { LeadListUpload } from "../../services/bankListUpload";
import { Dropdown } from "primereact/dropdown";
import { getUserData } from "../../utils/localStorage";
import { replaceUnderscoresWithSpaces, replaceUnderscoresWithSpacesAndUpperCase } from "../../components/Regex";
import { getBranch, getProduct, getStateWiseCities, getUser } from "../../services/userMasterUser";
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import { DataScroller } from 'primereact/datascroller';
import { Button } from "primereact/button";

export default function UserLeadInfoList() {

  const { state } = useLocation();

  console.log("state", state);

  const [products, setProducts] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);

  const navigate = useNavigate();

  const { userProfileData } = getUserData();

  const ds = useRef(null);

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(20);
  const [loadingMore, setLoadingMore] = useState(false);

  const typeData = {
    searchBy: "",
    searchText: "",
    limit: 20,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: [],
    sourceIn: [],
    leadIdIn: [state?.lead?.id]
  };

  const fetchData = (data, append = false) => {
    setLoadingMore(true);

    getUserLead(data)
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;

          // 🔥 Extract only the lead object
          // const newData = rawData.map(item => item.lead);

          if (append) {
            setProducts((prev) => [...(prev || []), ...rawData]);
          } else {
            setProducts(rawData);
          }
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };



  useEffect(() => {
    fetchData({
      ...typeData,
      limit: rows,
      offset: 0
    });

  }, []);




  const loadMore = () => {
    const newOffset = first + rows;

    fetchData(
      {
        ...typeData,
        limit: rows,
        offset: newOffset
      },
      true // append mode
    );

    setFirst(newOffset);
  };






  const itemTemplate = (data) => {
    return (
      <div>
      </div>
    )
  }

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">


                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <div >
                    <h5 className="card-title flex">
                      <div
                        className="mr-3 cursor-pointer"
                        onClick={() => navigate("/lead/list")}
                      >
                        <i class="bi bi-arrow-left-circle-fill"></i>
                      </div>Lead User Working Status List
                    </h5>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row col-md-12">
                    <div className="col-md-4 mb-2">
                      <p className="text-lg" style={{
                        fontWeight: 600,
                        color: 'blue'
                      }}>Lead Status: {state?.lead?.status}</p>
                    </div>
                    <div className="col-md-4 mb-2">
                      <p className="text-md" style={{
                        fontWeight: 600,
                        color: 'green'
                      }}>Last Update on: {formatDateWithTime(state?.lead?.lastModifiedDate)}</p>
                    </div>
                  </div>


                </div>

                <div className="dataview-demo">
                  <div className="card">
                    <DataTable
                      value={products}
                      // lazy
                      dataKey="id"
                      scrollable
                      scrollHeight="400px"
                      paginator
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rows={rows}
                      rowsPerPageOptions={[rows, rows + 50, rows + 100]}
                      loading={loadingMore}
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      stripedRows
                    >
                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design-without-btn"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>


                      <Column
                        field="name"
                        header="User Name"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {rowData?.user?.userName}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="userRole"
                        header="User Role"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {rowData.user?.role}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="createdOn"
                        header="Assigned On"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {formatDateWithTime(rowData?.createdDate)}
                          </span>
                        )}
                      ></Column>


                      <Column
                        field="LastModifyDate"
                        header="Last Modify On"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {formatDateWithTime(rowData?.lastModifiedDate)}
                          </span>
                        )}
                      ></Column>


                      <Column
                        field="status"
                        header="Working Status"
                        className="product-category table-design-without-btn"
                        body={(rowData) => (
                          <span>
                            {(rowData?.status)}
                          </span>
                        )}
                      ></Column>


                    </DataTable>
                  </div>
                  <DataScroller
                    ref={ds}
                    value={products}
                    itemTemplate={itemTemplate}
                    rows={5}
                    loader
                  // footer={footer} 
                  // header="Click Load Button at Footer to Load More" 
                  />
                  <div
                    className="flex justify-content-center fixed "
                    style={{ bottom: 30, left: 20 }}
                  >
                    <Button
                      type="text"
                      icon="pi pi-plus"
                      // label="More"
                      onClick={loadMore} // Update this to trigger `getData`
                    />
                  </div>
                  {/*products && products.length < totalRecords && (
                    <div style={{ textAlign: "center", margin: "20px" }}>
                      <button
                        onClick={loadMore}
                        disabled={loadingMore}
                        style={{
                          padding: "10px 20px",
                          backgroundColor: "#1e439b",
                          color: "#fff",
                          border: "none",
                          cursor: "pointer",
                          borderRadius: "5px"
                        }}
                      >
                        {loadingMore ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
